// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Nk5q","input":"styles_input__3xddL"};